import { ErrorType } from "../../../models/HttpError";
import { Settlement } from "../../../models/Entities/Settlements/Settlement";
import { SettlementDetail } from "../../../models/Entities/SettlementDetails/SettlementDetail";

// stores
import * as SettlementStore from '../../../redux/middleware/SettlementMiddleware';
import * as SettlementDetailStore from '../../../redux/middleware/SettlementDetailsMiddleware';

//State
import { AppState } from "../../../redux/reducers";
import { SettlementTotal } from "../../../models/Entities/SettlementTotals/SettlementTotals";

export const enum CharType {
    Line = 1,
    Donut = 2,
}

interface IProps {
    SettlementId: number;
    SettlementSummaryItemId?: number | undefined;
    CurrencyCode: string;
    ChartType: CharType;
}
  
  interface ConnectedProps {
    isLoading: boolean;
    isLoadingSuccessfully: boolean;
    failOnLoading: boolean;
    error: ErrorType | undefined;
    Settlement: Settlement | undefined;
    SettlementDetails: SettlementDetail[] | undefined;
    TotalToSettle: number;
    TotalWithholdings: number;
    OwnerAmount: number;
    OwnerWithholdings: number;
    OwnerTotal: number;
    TeamAmount: number;
    TeamWithholdings: number;
    TeamTotal: number;
  }
  
  interface DispatchProps {
    GetSettlementById: typeof SettlementStore.actionCreators.GetSettlementById;
    GetAllSettlementDetails: typeof SettlementDetailStore.actionCreators.GetAllSettlementDetails;
    //ChangeExcludeStatus: typeof SettlementDetailStore.actionCreators.ChangeExcludeStatus;
    //MarkOk: typeof SettlementDetailStore.actionCreators.MarkOk;
  }
  
  export type Props = IProps & ConnectedProps & DispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const CurrentSettlement = state.Settlement?.list?.find((item: Settlement) => item.id === ownProps.SettlementId);
    const CurrentSettlementTotal: SettlementTotal | null = CurrentSettlement?.totals?.find((total: SettlementTotal) => total.currencyCode === ownProps.CurrencyCode) || null;

    return {
        isLoading: CurrentSettlement?.isGettingDetails || false,
        isLoadingSuccessfully: CurrentSettlement?.isGettingDetailsSuccess || false,
        failOnLoading: CurrentSettlement?.failOnGettingDetails || false,
        error: CurrentSettlement?.ErrorGettingDetails,
        Settlement: CurrentSettlement,
        TotalToSettle: CurrentSettlementTotal?.totalValue,
        TotalWithholdings: CurrentSettlementTotal?.withholdRetention,
        OwnerAmount: CurrentSettlementTotal?.ownerAmount,
        OwnerWithholdings: CurrentSettlementTotal?.ownerAmountWithholding,
        OwnerTotal: CurrentSettlementTotal?.ownerAmountWithholdingTotal,
        TeamAmount: CurrentSettlementTotal?.teamAmount,
        TeamWithholdings: CurrentSettlementTotal?.teamAmountWithholding,
        TeamTotal: CurrentSettlementTotal?.teamAmountWithholdingTotal
        }
    };
  
  export const mapDispatchToProps = {
    ...SettlementStore.actionCreators,
    ...SettlementDetailStore.actionCreators
  };

  function uniqueFilter(value: any, index: any, self: any) {
    return self.indexOf(value) === index;
  };

  export const GetPatientStageTotal = (props: Props, patient: string, stage: string, currencyCode: string):number | undefined => {
     var sum = props.SettlementDetails?.filter((item: SettlementDetail )=> item.patientNumberInProtocol === patient && item.contractStageName === stage && item.currency === currencyCode)
          .reduce((sum, current) => sum + current.amount, 0);
      return sum;
  };

  export const GetPatientStageCurrencies = (props: Props, patient: string, stage: string):string[] | undefined => {
    var currencies = props.SettlementDetails?.filter((item: SettlementDetail )=> item.patientNumberInProtocol === patient && item.contractStageName === stage)
         .map((item: SettlementDetail) => item.currency).filter(uniqueFilter);
     return currencies;
  };